import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import {number, translate} from 'filters'
import React from 'react'
import {AuctionFilter, changeAuctionedFilter, setAuctionFilter, SubjectType} from 'redux/actions'
import {connect} from 'react-redux'
import {GlobalState} from '../../../state'
import {IndicatorsState} from '../../../redux/reducers/IndicatorReducer'
import moment from 'moment'
import {history} from '../../../Router/Router'
import Trans from '../../Trans'

type AuctionedVehiclesStatisticProps = {
  indicators: IndicatorsState
  filter: AuctionFilter
  subjectType: SubjectType
}

export type AuctionStatisticValue = 'last-month' | 'current-month' | 'current-year' | 'last-year' | 'all-time'

type AuctionStatisticRange = Array<{
  label: string, value: AuctionStatisticValue
}>

type AuctionedVehiclesStatisticState = {
  statisticOptions: AuctionStatisticRange
  selectedOption: AuctionStatisticValue
}

class AuctionedVehiclesStatistic extends React.Component<AuctionedVehiclesStatisticProps, AuctionedVehiclesStatisticState> {
  constructor(props: AuctionedVehiclesStatisticProps) {
    super(props)

    this.state = {
      statisticOptions: [
        {label: translate('letzter Monat'), value: 'last-month'},
        {label: translate('aktueller Monat'), value: 'current-month'},
        {label: translate('aktuelles Jahr'), value: 'current-year'},
        {label: translate('letztes Jahr'), value: 'last-year'},
        {label: translate('insgesamt'), value: 'all-time'}
      ],
      selectedOption: props.indicators.filters.auctioned || 'current-month'
    }
  }

  showAuctioned = async (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()

    if (this.state.selectedOption === 'all-time') {
      await setAuctionFilter(this.props.filter, {
        type: 'auctioned'
      }, this.props.subjectType)

      return history.push('/')
    }

    let start = moment().startOf('month')
    let end = moment().endOf('month')

    if (this.state.selectedOption === 'last-month') {
      start = moment().subtract(1, 'month').startOf('month')
      end = moment().subtract(1, 'month').endOf('month')
    }

    if (this.state.selectedOption === 'current-year') {
      start = moment().startOf('year')
      end = moment().endOf('year')
    }

    if (this.state.selectedOption === 'last-year') {
      start = moment().subtract(1, 'year').startOf('year')
      end = moment().subtract(1, 'year').endOf('year')
    }

    await setAuctionFilter(this.props.filter, {
      type: 'auctioned',
      AcceptedOn: {
        from: start.format('Y-MM-DD HH:mm:ss'),
        to: end.format('Y-MM-DD HH:mm:ss')
      }
    }, this.props.subjectType)
    return history.push('/')
  }

  render() {
    return (
      <div className='statistic_box rounded' onClick={this.showAuctioned}>
        <div className='statistic_box_body'>
          <h2>{translate('Ersteigerte Fahrzeuge')}</h2>
          <p>{translate('Anzahl Fahrzeuge, die Sie ersteigert haben.')}</p>
          <div className='stat'>
            <Icon icon='trophy' className='fa-4x mr-4 fa-fw' />
            <span className='font-semibold text-2xl'>{number(this.props.indicators.auctioned, 0, 'x')}</span>
          </div>
          <div>
            <select value={this.state.selectedOption} className={'bg-teal-200 text-teal-800'} onClick={e => {
              e.preventDefault()
              e.stopPropagation()
            }} onChange={async (e) => {
              this.setState({selectedOption: e.target ? e.target.value as AuctionStatisticValue : 'current-month'})
              await changeAuctionedFilter(e.target ? e.target.value as AuctionStatisticValue : 'current-month')
            }}>
              {this.state.statisticOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    )
  }
}

export default connect((store: GlobalState) => ({
  indicators: store.indicators,
  filter: store.auctions.filter,
  subjectType: store.app.subjectType
}))(AuctionedVehiclesStatistic)
